import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { PrimeIcons } from "primereact/api";

import { useAppDispatch, useAppSelector } from "store/store";
import { inputRole, labelAdmin, labelEditor, labelUser } from "_constants";
import { setRoleUtenti } from "store/slicer/GestioneUsersSlice";
import { Controller, useForm } from "react-hook-form";

export const InputUserRole = () => {
  const { control, setValue } = useForm({
    defaultValues: {
      role: "",
    },
    mode: "onChange",
  });
  const dispatch = useAppDispatch();
  const role = useAppSelector((state) => state.gestioneUsersSlice.filters.role);

  const roleOptions = [
    { name: labelAdmin, value: 1 },
    { name: labelUser, value: 2 },
    { name: labelEditor, value: 3 },
  ];

  const onChangeValue = (event: DropdownChangeEvent) => {
    if (event.value) {
      setValue("role", event.value);
      dispatch(setRoleUtenti(event.value - 1));
    } else {
      setValue("role", "");
      dispatch(setRoleUtenti(null));
    }
  };

  return (
    <Controller
      name="role"
      control={control}
      render={({ field }) => (
        <Dropdown
          dataKey="role"
          id={field.name}
          {...field}
          onChange={onChangeValue}
          options={roleOptions}
          optionLabel="name"
          optionValue="value"
          placeholder={inputRole}
          aria-label={inputRole}
          clearIcon={PrimeIcons.TIMES}
          showClear={role !== null && role > -1}
        />
      )}
    />
  );
};
